// Dev-only, including when someone builds with --mode development. SSR is
// excluded because the existing home prerender uses Vite's development SSR loader.
export const SOLUTIONS_PREVIEW_ENABLED = import.meta.env.DEV && !import.meta.env.SSR

// Explicit opt-in, shared by the client and build-time renderer. The home menu
// deliberately keeps using the DEV-only flag above.
export const INFORMATION_PUBLIC_ENABLED = import.meta.env.VITE_INFORMATION_PUBLIC === 'true'
export const INFORMATION_ROUTES_ENABLED = SOLUTIONS_PREVIEW_ENABLED || INFORMATION_PUBLIC_ENABLED

export function isSolutionsPreviewPath(pathname: string) {
  return INFORMATION_ROUTES_ENABLED && (pathname === '/solutions' || pathname.startsWith('/solutions/') ||
    ['/pricing', '/for-drivers', '/about', '/articles'].includes(pathname) || pathname.startsWith('/articles/'))
}
